/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrekksoftClientCredential } from './TrekksoftClientCredential';
import {
    TrekksoftClientCredentialFromJSON,
    TrekksoftClientCredentialFromJSONTyped,
    TrekksoftClientCredentialToJSON,
    TrekksoftClientCredentialToJSONTyped,
} from './TrekksoftClientCredential';

/**
 * 
 * @export
 * @interface CreateTrekksoftClientCredentialsResponse
 */
export interface CreateTrekksoftClientCredentialsResponse {
    /**
     * 
     * @type {TrekksoftClientCredential}
     * @memberof CreateTrekksoftClientCredentialsResponse
     */
    data: TrekksoftClientCredential;
}

/**
 * Check if a given object implements the CreateTrekksoftClientCredentialsResponse interface.
 */
export function instanceOfCreateTrekksoftClientCredentialsResponse(value: object): value is CreateTrekksoftClientCredentialsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateTrekksoftClientCredentialsResponseFromJSON(json: any): CreateTrekksoftClientCredentialsResponse {
    return CreateTrekksoftClientCredentialsResponseFromJSONTyped(json, false);
}

export function CreateTrekksoftClientCredentialsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTrekksoftClientCredentialsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TrekksoftClientCredentialFromJSON(json['data']),
    };
}

  export function CreateTrekksoftClientCredentialsResponseToJSON(json: any): CreateTrekksoftClientCredentialsResponse {
      return CreateTrekksoftClientCredentialsResponseToJSONTyped(json, false);
  }

  export function CreateTrekksoftClientCredentialsResponseToJSONTyped(value?: CreateTrekksoftClientCredentialsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TrekksoftClientCredentialToJSON(value['data']),
    };
}

